import * as React from 'react'
function SvgDoubleCheck(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M32.096 10.034a1.778 1.778 0 011.83 2.73l-10.667 16c-.296.443-.774.73-1.303.783-.063.009-.12.009-.178.009a1.778 1.778 0 01-1.257-.516l-2.517-2.517 2.01-3.023 1.488 1.488 9.463-14.197a1.778 1.778 0 011.131-.757zm-7.554.265a1.778 1.778 0 01.493 2.465l-10.667 16c-.293.446-.77.736-1.301.792h-.178c-.472 0-.924-.188-1.257-.521L6.299 23.7a1.778 1.778 0 112.513-2.513l3.801 3.8 9.463-14.197a1.778 1.778 0 012.466-.492z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDoubleCheck
